import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/** Guards tenant routes. Show a small loader while auth state is unknown. */
export default function ProtectedRoute({ children }) {
    const { session } = useAuth();
    const loc = useLocation();

    if (session === null) {
        return (
            <div className="min-h-screen grid place-items-center bg-background" data-testid="auth-loading">
                <div className="flex flex-col items-center gap-3">
                    <div className="h-8 w-8 rounded-full border-2 border-border border-t-foreground animate-spin" />
                    <span className="text-xs text-muted-foreground">Oturum kontrol ediliyor…</span>
                </div>
            </div>
        );
    }

    if (session === false) {
        return <Navigate to="/" state={{ from: loc.pathname }} replace />;
    }

    return children;
}
